module.exports = __webpack_public_path__ + "img/bg.517a2e13.png";